import { Maybe } from 'maybeasy';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { T } from '../../../../../../Translations';
import { findLink } from '../../../../../../LinkyLinky';
import { currentUserStore } from '../../../../../../CurrentUserStore';

export interface Props {
  id: number;
}

export const manageCommunicationsLink = ({ id }: Props): Maybe<React.ReactNode> =>
  findLink('communication-overrides-index', currentUserStore.links).map(() => (
    <Link
      key="Manage Communications"
      to={`/learning_collections/${id}/communications`}
      className="px-4 py-2.5"
      data-intercom-target="manage-communications-action"
    >
      <T kind="Manage Communications" />
    </Link>
  ));
